module.exports = __webpack_public_path__ + "static/media/2017_conf_MVPs_are_too_Expensive.10808fc6.png";